module.exports = __webpack_public_path__ + "static/img/LU.bfe9007d.svg";